import React, { useEffect } from "react";
import "../SRT/SrtTabs.css";
import Dickies from "../SR/Dickies/Dickies";
import { Tabs } from "antd";
import Saucony from "../SR/Saucony/Saucony";
import Eddie from "../SR/Eddie Bauer/Eddie";
import MyFavoriteSocks from "../SR/MyFavoriteSocks/MyFavoriteSocks";
// import PdRedevelopment from "../SR/PdRedevelopment/PdRedevelopment";
import NorthState from "../SR/NorthState/NorthState";
import Inferno from "../SR/Inferno/Inferno";
import TrueEnergy from "../SR/TrueEnergy/TrueEnergy";
import NorthStateApparel from "../SR/NorthStateApparel/NorthStateApparel";
import RunDry from "../SR/RunDry/RunDry";
import {
  getSrInitialList,
  srBrandName,
  resetSrMassFilter,
  resetSrSeasonFilter,
  srExport
} from "../../Redux/actions/Sr/Sr";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const { TabPane } = Tabs;

const SrTabs = (containerRef) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const path = location.pathname;



  useEffect(() => {
    if (path.includes("/m3-setup-sheet/dickies-socks")) {
      dispatch(srBrandName("Dickies Socks"));
      localStorage.setItem("currentPage", 0);
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/saucony")) {
      dispatch(srBrandName("Saucony"));
      localStorage.setItem("currentPage", 0);
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/eddie-bauer")) {
      dispatch(srBrandName("EddieBauer"));
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/pd")) {
      dispatch(srBrandName("PD"));
      localStorage.setItem("currentPage", 0);
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/my-favorite-socks")) {
      dispatch(srBrandName("My Favorite Socks"));
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/north-state")) {
      dispatch(srBrandName("NorthState"));
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/inferno")) {
      dispatch(srBrandName("Inferno"));
      dispatch(resetSrSeasonFilter());
    } else if (path.includes("/m3-setup-sheet/true-energy")) {
      dispatch(srBrandName("True Energy"));
      dispatch(resetSrSeasonFilter());
    }else if (path.includes("/m3-setup-sheet/north-state-apparel")) {
      dispatch(srBrandName("North State Apparel"));
      dispatch(resetSrSeasonFilter());
    }else if (path.includes("/m3-setup-sheet/run-dry")) {
      dispatch(srBrandName("RunDry"));
      dispatch(resetSrSeasonFilter());
    }
    else {
      dispatch(resetSrSeasonFilter());
      dispatch(srBrandName("Dickies Underwear"));
    }
    localStorage.setItem("activeKey", "4");
    if (path === "/m3-setup-sheet/dickies-socks") {
      localStorage.setItem("srtActiveKey", "1");
    }
    if (path === "/m3-setup-sheet/saucony") {
      localStorage.setItem("srtActiveKey", "2");
    }
    if (path == "/m3-setup-sheet/eddie-bauer") {
      localStorage.setItem("srtActiveKey", "3");
    }
    if (path == "/m3-setup-sheet/pd") {
      localStorage.setItem("srtActiveKey", "4");
    }
    if (path == "/m3-setup-sheet/my-favorite-socks") {
      localStorage.setItem("srtActiveKey", "7");
    }
    if (path == "/m3-setup-sheet/north-state") {
      localStorage.setItem("srtActiveKey", "10");
    }
    if (path == "/m3-setup-sheet/inferno") {
      localStorage.setItem("srtActiveKey", "11");
    }
    if (path == "/m3-setup-sheet/true-energy") {
      localStorage.setItem("srtActiveKey", "12");
    }
    if (path == "/m3-setup-sheet/north-state-apparel") {
      localStorage.setItem("srtActiveKey", "13");
    }
    if (path == "/m3-setup-sheet/run-dry") {
      localStorage.setItem("srtActiveKey", "14");
    }
  }, [path]);

  const onKeyChange = (key) => {
    if (key == 1) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "Dickies Socks",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("Dickies Socks", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/dickies-socks?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "1");
      dispatch(srBrandName("Dickies Socks"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 2) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "Saucony",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("Saucony", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/saucony?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "2");
      dispatch(srBrandName("Saucony"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 3) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "EddieBauer",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/eddie-bauer?page=1&pageSize=100");
      dispatch(getSrInitialList("EddieBauer", "", "", 0, "", "", 1, 100));
      localStorage.setItem("srActiveKey", "3");
      dispatch(srBrandName("EddieBauer"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 4) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "PD",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/pd?page=1&pageSize=100");
      dispatch(getSrInitialList("PD", "", "", 0, "", "", 1, 100));
      localStorage.setItem("srActiveKey", "4");
      dispatch(srBrandName("PD"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 7) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "My Favorite Socks",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("My Favorite Socks", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/my-favorite-socks?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "7");
      dispatch(srBrandName("My Favorite Socks"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 10) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "NorthState",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("NorthState", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/north-state?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "10");
      dispatch(srBrandName("NorthState"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 11) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "Inferno",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("Inferno", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/inferno?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "11");
      dispatch(srBrandName("Inferno"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 12) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "True Energy",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("True Energy", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/true-energy?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "12");
      dispatch(srBrandName("True Energy"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 13) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "North State Apparel",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("North State Apparel", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/north-state-apparel?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "13");
      dispatch(srBrandName("North State Apparel"));
      dispatch(resetSrSeasonFilter());
    } else if (key == 14) {
      localStorage.setItem(
        "srData",
        JSON.stringify({
          brandFilter: "RunDry",
          searchFilter: "",
          colorFilter: "",
          sizeFilter: "",
          vendorFilter: "",
          sale_sampleFilter: 0,
          seasonFilter: "",
        })
      );
      dispatch(getSrInitialList("RunDry", "", "", 0, "", "", 1, 100));
      localStorage.removeItem("srMassData");
      localStorage.removeItem("massSrFilterData");
      navigate("/m3-setup-sheet/run-dry?page=1&pageSize=100");
      localStorage.setItem("srActiveKey", "14");
      dispatch(srBrandName("RunDry"));
      dispatch(resetSrSeasonFilter());
    }
  };

  const activeKey = localStorage.getItem("srActiveKey");

  return (
    <div className="srt-tabs">
      <Tabs activeKey={activeKey ? activeKey : "1"} onChange={onKeyChange}>
        <TabPane
          className="tab-one"
          tab={<div className="tab-one-background">DICKIES</div>}
          key={"1"}
        >
          <Dickies containerRef={containerRef} />
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-two-background">SAUCONY</div>}
          key={"2"}
        >
          <Saucony containerRef={containerRef}/>
        </TabPane> */}
        <TabPane
          tab={<div className="tab-three-background">EB</div>}
          key={"3"}
        >
          <Eddie containerRef={containerRef} />
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-four-background">PD & REDEVELOPMENT</div>}
          key={"4"}
        >
          <PdRedevelopment containerRef={containerRef} />
        </TabPane> */}
        <TabPane
          tab={<div className="tab-nine-background">MFS</div>}
          key={"7"}
        >
          <MyFavoriteSocks containerRef={containerRef}/>
        </TabPane>
        <TabPane
          tab={<div className="tab-ten-background">NORTHSTATE</div>}
          key={"10"}
        >
          <NorthState containerRef={containerRef}/>
        </TabPane>
        {/* <TabPane
          tab={<div className="tab-eleven-background">INFERNO</div>}
          key={"11"}
        >
          <Inferno containerRef={containerRef} />
        </TabPane> */}
         <TabPane
          tab={<div className="tab-twelve-background">TRUE ENERGY</div>}
          key={"12"}
        >
          <TrueEnergy containerRef={containerRef} />
        </TabPane>
        <TabPane
          tab={<div className="tab-thirteen-background">NORTHSTATE APPAREL</div>}
          key={"13"}
        >
          <NorthStateApparel containerRef={containerRef} />
        </TabPane>
        <TabPane
          tab={<div className="tab-forteen-background">RUNDRY</div>}
          key={"14"}
        >
          <RunDry containerRef={containerRef} />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default SrTabs;
